import { Result } from "@/main/models/common/resultResponse";
import { RateGridRequest, RateSaveRequest, DeleteRateRequest } from "@/main/models/request/rateRequest";
import { RateRegistrationDataResponse, RateResponse } from "@/main/models/response/rateResponse";
import { AxiosResponse } from "axios";
import { api, IRateApi } from "./base";

const baseRoute: string = "Rate";

export class RateApi extends IRateApi {
	searchGrid(request: RateGridRequest): Promise<AxiosResponse<Result<RateResponse[]>>> {
		return api.get(`${baseRoute}/searchgrid`, { params: request });
	}

	save(request: RateSaveRequest): Promise<AxiosResponse<Result<RateResponse>>> {
		return api.post(`${baseRoute}/save`, request);
	}

	deleteRate(request: DeleteRateRequest): Promise<AxiosResponse<Result<any>>> {
		return api.delete(`${baseRoute}/delete`, { data: request });
	}

	getRateRegistrationData(guidRate: string): Promise<AxiosResponse<Result<RateRegistrationDataResponse>>> {
		return api.get(`${baseRoute}/${guidRate}`);
	}
}
